// import React, { useState } from 'react';
// import { Layout, Menu, Dropdown, Button, Modal } from 'antd';
// import './style.css';

// const { Footer } = Layout;

// const Footers = ({ refs }) => {
//   const [isModalVisible, setIsModalVisible] = useState(false);

//   const scrollToRef = (ref) => {
//     if (ref?.current) {
//       ref.current.scrollIntoView({ behavior: 'smooth' });
//       setIsModalVisible(false); // Close modal after click
//     }
//   };

//   const items = [
//     { key: 'home', label: 'Home', ref: refs.homeRef },
//     { key: 'about', label: 'About', ref: refs.aboutRef },
//     { key: 'team', label: 'Team', ref: refs.teamRef },
//     { key: 'documents', label: 'Disclosures', ref: refs.documentsRef },
//     { key: 'contact', label: 'Contact Us', ref: refs.contactRef },
//   ];

//   return (
//     <Footer className="custom-footer">
//       <div className="footer-menu-wrapper">
//         <Menu
//           theme="light"
//           mode="horizontal"
//           className="custom-f-menu"
//         >
//           {items.slice(0, 3).map((item) => (
//             <Menu.Item key={item.key} onClick={() => scrollToRef(item.ref)}>
//               {item.label}
//             </Menu.Item>
//           ))}
//           <Menu.Item key="more" onClick={() => setIsModalVisible(true)}>
//             More
//           </Menu.Item>
//         </Menu>
//       </div>

//       <Modal
//         title="More Options"
//         open={isModalVisible}
//         onCancel={() => setIsModalVisible(false)}
//         footer={null}
//         centered
//       >
//         {items.slice(3).map((item) => (
//           <Button
//             key={item.key}
//             type="text"
//             block
//             onClick={() => scrollToRef(item.ref)}
//           >
//             {item.label}
//           </Button>
//         ))}
//       </Modal>
//     </Footer>
//   );
// };

// export default Footers;

// import React from 'react';
// import { Layout, Menu } from 'antd';
// import './style.css';
// import { Link } from 'react-router-dom'; // ✅ add this

// const { Footer } = Layout;

// const Footers = ({ refs }) => {
//   const scrollToRef = (ref) => {
//     if (ref?.current) {
//       ref.current.scrollIntoView({ behavior: 'smooth' });
//     }
//   };

//   const items = [
//     { key: 'home', label: 'Home', ref: refs.homeRef },
//     { key: 'about', label: 'About', ref: refs.aboutRef },
//     { key: 'team', label: 'Team', ref: refs.teamRef },
//     { key: 'documents', label: 'Disclosures', ref: refs.documentsRef },
//     { key: 'contact', label: 'Contact Us', ref: refs.contactRef },
//     { key: 'privacyPolicy', lable: 'Privacy Policy' }
//   ];

//   return (
//     <Footer className="custom-footer">
//       <div className="footer-menu-wrapper">
//         <Menu theme="light" mode="horizontal" className="custom-f-menu">
//           {items.map((item) => (
//             <Menu.Item key={item.key} onClick={() => scrollToRef(item.ref)}>
//               {item.label}
//             </Menu.Item>
//           ))}
//         </Menu>
//       </div>

//       {/* ✅ Add a small second row with the Privacy Policy SPA link */}
//       <div className="footer-legal-row">
//         <Link to="/privacy-policy" className="footer-link">
//           Privacy Policy
//         </Link>
//       </div>

//     </Footer>
//   );
// };

// export default Footers;



// src/Components/Footer.jsx
import React from 'react';
import { Layout, Menu } from 'antd';
import { Link } from 'react-router-dom';
import './style.css';
import PrivacyPolicy from '../../Pages/PrivacyPolicy';

const { Footer } = Layout;

const Footers = ({ refs, onOpenPolicy }) => {
  const scrollToRef = (ref) => ref?.current?.scrollIntoView({ behavior: 'smooth' });

  const items = [
    { key: 'home', label: 'Home', ref: refs.homeRef },
    { key: 'about', label: 'About', ref: refs.aboutRef },
    { key: 'team', label: 'Team', ref: refs.teamRef },
    { key: 'documents', label: 'Disclosures', ref: refs.documentsRef },
    { key: 'contact', label: 'Contact Us', ref: refs.contactRef },
  ];


  const handleOpenPolicy = (e) => {
    e.preventDefault();
    if (onOpenPolicy) onOpenPolicy(); // ✅ guard
  };

  return (
    <Footer className="custom-footer">
      <div className="footer-menu-wrapper">
        <Menu
          theme="light"
          mode="horizontal"
          selectable={false}
          overflowedIndicator={null}       // ✅ removes the “…” menu
          className="custom-f-menu"
        >
          {items.map((item) => (
            <Menu.Item key={item.key} onClick={() => scrollToRef(item.ref)}>
              {item.label}
            </Menu.Item>
          ))}
        </Menu>
      </div>

      <div className="footer-legal-row">

        <button
          type="button"
          className="footer-link"
          onClick={() => {
            if (onOpenPolicy) onOpenPolicy();
          }}
          style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer' }}
        >
          Privacy Policy
        </button>

      </div>
    </Footer>
  );
};

export default Footers;

